const getJSON = async (url: string) => {
  let output = null;
  try {
    output = await fetch(url);
  } catch (error) {
    return error;
  }
  return await output.json();
};

export default getJSON;
